var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIconBroadcast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8862 1.55198C14.9063 1.61635 14.9165 1.68339 14.9165 1.75083V13.2706C14.9165 13.6388 14.618 13.9372 14.2498 13.9372C14.1824 13.9372 14.1154 13.927 14.051 13.9069L9.56332 12.5044C9.4021 13.8229 8.27855 14.844 6.9165 14.844C5.44374 14.844 4.24984 13.6501 4.24984 12.1774L4.24975 10.844L2.9165 10.844C1.83278 10.844 0.950368 9.98208 0.917456 8.90633L0.916504 8.84403V6.17737C0.916504 5.0728 1.81193 4.17737 2.9165 4.17737H4.24984L14.051 1.11451C14.4024 1.00469 14.7763 1.20055 14.8862 1.55198ZM5.58317 11.324V12.1774C5.58317 12.9137 6.18012 13.5107 6.9165 13.5107C7.61941 13.5107 8.19528 12.9668 8.24618 12.2769L8.24984 12.1574L5.58317 11.324ZM13.5832 2.65737L5.58317 5.1567V9.86404L13.5832 12.3634V2.65737ZM4.24984 5.5107H2.9165C2.57461 5.5107 2.29283 5.76806 2.25432 6.09962L2.24984 6.17737V8.84403C2.24984 9.21222 2.54831 9.5107 2.9165 9.5107H4.24984V5.5107Z",
    fill: "#0A9A32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIconBroadcast);
export default __webpack_public_path__ + "static/media/chat-icon-broadcast.d9400b142ac47c497e38377d54dc0338.svg";
export { ForwardRef as ReactComponent };